import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import { NitroPanel, NitroSingleSelect } from 'nitro-components';
import DetailedSearchResultContainer from './DetailedSearchResultContainer';

import { ITEM_PER_PAGE_OPTIONS } from './content';
import Breakpoint from '../../../../utils/breakpoints';

import {
  getInputText,
  getSeletedNum,
  getSeletedType,
  onSelectNum,
  getSearchResults
} from '../store/action';

import {
  GoBackContainer,
  EntryCountContainer,
  Container,
  NumPerPageSelector,
  NumPerPageOptionContainer,
  SearchResultStyleHeader,
  SearchResultContainer,
  Main
} from './ResultStyle';

const SearchResults = (
  { selected, options, onSelect, searchTerm, searchType, total },
  context
) => {
  const goBack = () => {
    const { router } = context;
    router.goBack();
  };

  return (
    <Main>
      <GoBackContainer>
        <span onClick={goBack}>Back</span>
      </GoBackContainer>
      <Breakpoint name="mobileTablet">
        <EntryCountContainer>
          <SearchResultStyleHeader>
            {`${total} results for ${searchType.includes('ID')
              ? searchType.charAt().toLowerCase() + searchType.slice(1)
              : searchType.toLowerCase()
              }`}
            <span>{` ${searchTerm}`}</span>
          </SearchResultStyleHeader>

          <NumPerPageOptionContainer>
            <p>Showing </p>
            <NumPerPageSelector>
              <NitroSingleSelect
                value={selected}
                options={options}
                mandatory
                bold
                action={onSelect}
              />
            </NumPerPageSelector>
            <p> entries</p>
          </NumPerPageOptionContainer>
        </EntryCountContainer>
      </Breakpoint>
      <Container>
        <NitroPanel>
          <Breakpoint name="desktop">
            <SearchResultStyleHeader>
              {`${total} results for ${searchType.includes('ID')
                ? searchType.charAt().toLowerCase() + searchType.slice(1)
                : searchType.toLowerCase()
                }`}
              <span>{` ${searchTerm}`}</span>
            </SearchResultStyleHeader>

            <NumPerPageOptionContainer>
              <p>Showing </p>
              <NumPerPageSelector>
                <NitroSingleSelect
                  value={selected}
                  options={options}
                  mandatory
                  bold
                  action={onSelect}
                />
              </NumPerPageSelector>
              <p> entries</p>
            </NumPerPageOptionContainer>
          </Breakpoint>
          <Breakpoint name="mobileTablet">
            <DetailedSearchResultContainer />
          </Breakpoint>

          <Breakpoint name="desktop">
            <SearchResultContainer>
              <DetailedSearchResultContainer />
            </SearchResultContainer>
          </Breakpoint>
        </NitroPanel>
      </Container>
    </Main>
  );
};

SearchResults.contextTypes = {
  router: PropTypes.shape({})
};

const mapStateToProps = state => {
  const { total } = getSearchResults(state);
  return {
    searchTerm: getInputText(state),
    searchType: getSeletedType(state),
    selected: getSeletedNum(state),
    options: ITEM_PER_PAGE_OPTIONS,
    total
  };
};

const mapDispatchToProps = dispatch => ({
  onSelect: bindActionCreators(onSelectNum, dispatch)
});

SearchResults.defaultProps = {
  selected: 10,
  options: ITEM_PER_PAGE_OPTIONS
};

SearchResults.propTypes = {
  searchTerm: PropTypes.string,
  options: PropTypes.array,
  selected: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchResults);



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearchBar/SearchResultGrid/index.js